<template>
  <div>
    <v-container>
      <div>
        <div @click="showCreate" class="add-product mb-3">
          <em class="fas fa-plus mr-2" />
          เพิ่มกลุ่ม
        </div>
        <v-pagination
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
        <div class="pa-2 mt-3" style="background-color: #eee; border-radius: 6px">
          <v-layout row wrap class="pl-5 ma-0">
            <v-flex xs9>
              <div style="font-weight: bold">ชื่อกลุ่ม</div>
            </v-flex>
            <v-flex xs3></v-flex>
          </v-layout>
        </div>
        <div v-if="loading" class="text-xs-center pt-5">
          <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
        </div>
        <div v-else>
          <div v-for="(item, k) in data" :key="k">
            <v-layout row wrap class="ma-0 px-5">
              <v-flex xs9 class="mt-2">{{ item.name }}</v-flex>
              <v-flex xs3 class="text-xs-right">
                <v-btn @click="showEdit(item)" small color="primary" flat icon
                  ><v-icon small>edit</v-icon></v-btn
                >
                <v-btn @click="onDelete(item)" small color="primary" flat icon
                  ><v-icon small>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
            <div class="px-3">
              <v-divider></v-divider>
            </div>
          </div>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="editModal" width="600px" persistent>
      <v-card v-if="editModal">
        <PageGroupEdit
          @onSave="onSave"
          @close="editModal = false"
          :edittype="edittype"
          :editdata="editdata"
        ></PageGroupEdit>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PageGroupEdit from './PageGroupEdit.vue'
export default {
  components: {
    PageGroupEdit
  },
  data() {
    return {
      loading: false,
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      data: [],
      editModal: false,
      edittype: '',
      editdata: ''
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getData()
  },
  methods: {
    onDelete(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              id: item.id
            }
            this.loading = true
            api.deletePowerbuyGroup(data, (response) => {
              this.loading = false
              this.onSave()
            })
          }
        })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getData() {
      this.loading = true
      var data = {
        pageid: this.selectedBot.pageid,
        limit: this.limit,
        offset: this.offset
      }
      api.getPowerbuyGroup(data, (err, response) => {
        this.loading = false
        this.data = response.data
        this.total = response.total
      })
    },
    showCreate() {
      this.edittype = 'create'
      this.editModal = true
    },
    showEdit(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.editModal = true
    },
    onSave() {
      this.editModal = false
      this.getData()
    }
  }
}
</script>

<style lang="scss">
.add-product {
  height: 80px;
  border: dashed rgb(189, 189, 189) 3px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(189, 189, 189);
  cursor: pointer;
  border-radius: 10px;
  font-size: 23px;
  transition: all 0.1s ease-out;
}
.add-product:hover {
  color: #ee6e73;
  border: dashed #ee6e73 3px;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/PageGroup.vue